import React,{useState} from 'react';
import {compose, defaultProps} from 'recompose';
import {hot} from 'react-hot-loader';
import {Form, Input, Button, Select, Search} from 'semantic-ui-react';

import {withLocale} from 'op/components/locale';
import {withUnits} from './search-filter.helper';

const SearchFilter = ({locale, units, unit, selectUnit, jobs, job, onJobSelect, readiness, onReadinessSelect, onClose }) => (

    <Form>
        <Form.Field>
            <label>Readiness Level</label>
            <Button.Group>
                <Button color='red' onClick={() => onReadinessSelect(3)}></Button>
                <Button color='yellow' onClick={() => onReadinessSelect(2)}></Button>
                <Button color='green' onClick={() => onReadinessSelect(1)}></Button>
                <Button onClick={() => onReadinessSelect(null)}>All</Button>
            </Button.Group>
        </Form.Field>
        <Form.Field
            control={Select}
            label={locale.unit}
            search
            value={unit && unit.id}
            onChange={(e, {value}) => selectUnit(units.find(({id}) => id === value))}
            options={units.map(({id, name}) =>
                ({key: id, text: name, value: id}))
            }
            placeholder={locale.unit}/>
        <Form.Field
            control={Select}
            label={locale.job}
            search
            value={job && job.id}
            disabled={!unit}
            onChange={(e, {value}) => onJobSelect(jobs.find(({id}) => id === value))}
            options={jobs
                .filter(({unit_id}) => unit && unit_id === unit.id)
                .map(({id, name}) =>
                    ({key: id, text: name, value: id}))
            }
            placeholder={locale.job}/>
        <Form.Button
            basic
            color='orange'
            fluid
            disabled={!job && !unit && !readiness}
            onClick={() => {
                selectUnit(null);
                onReadinessSelect(null);
            }}
            content={locale._system.clear}
        />
        <Form.Button
            basic
            color='grey'
            fluid
            onClick={() => onClose()}
            content={locale._system.close}
        />
    </Form>
);

export default compose(
    withLocale('person.search'),
    withUnits,
    hot(module),
)(SearchFilter);